import React from "react";
import websiteData from '../data.json';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import CoverHeaderXs from '../components/header/cover-header-xs';
import Heading2Paragraph from '../components/titles/heading2-paragraph';
import SectionContainer from '../components/containers/section-container';
import GenericParagraph from '../components/paragraphs/Paragraph';
import { Row, Col } from 'react-bootstrap';
import Heading3 from '../components/titles/Heading3';
import Carousel from '../components//carousel/owlCarousel';
import FeaturesAccordionSection from '../components/features/featuresaccordion';
import VisibilitySensor from 'react-visibility-sensor';
import ReactGA from 'react-ga';

export const initGA = () => {
    /* console.log('Ga init'); */
     ReactGA.initialize('UA-90162173-1'); 
}

export const logPageView = () => {
    /* console.log(window.location.pathname); */
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
}

class CareerPage extends React.Component {
    constructor() {
        super();
        this.state = {
            animated : false,
            animationClasses : [''],
        };
        this.headerVisible = this.headerVisible.bind(this);
    }

    componentDidMount() {
        initGA();
        logPageView();
    }

    headerVisible(isVisible) {
        if (isVisible) {
            if (!this.state.animated) {
                var elemIndex = this.props.index,
                timeDelay =+ elemIndex * 200;
                setTimeout(function() { 
                    var classes = this.state.animationClasses;
                    classes.push('animate-box');
                    classes.push('fadeInUp');
                    classes.push('animated-fast');
                    this.setState({ animated: true, animationClasses: classes}); 
                }.bind(this), timeDelay);
            }
        }
    };
    render() {
        const careerPage = websiteData.careerPage,
              dataCoverHeaderXs = careerPage.CoverHeaderXs[0],
              dataCareerDevelopYourself = careerPage.careerDevelopYourself,
              dataLeftDeveloperYourselfParagraph = careerPage.leftDeveloperYourselfParagraph,
              dataRightDeveloperYourselfParagraph = careerPage.rightDeveloperYourselfParagraph,
              dataCareerOurOffice = careerPage.careerOurOffice[0],
              dataCareerOurOfficeSubtitleParagraph = careerPage.careerOurOfficeSubtitleParagraph,
              dataCareerOurOfficeListRight = careerPage.careerOurOfficeListRight,
              dataCareerOurOfficeListLeft = careerPage.careerOurOfficeListLeft,
              dataCarouselItems = careerPage.carouselItems,
              dataCareerOurOpenings = careerPage.careerOurOpenings,
              dataCareerOurOpeningsParagraph = careerPage.careerOurOpeningsParagraph,
              dataCarrerOpenPositions= careerPage.FeaturesAccordionSection.carrerOpenPositions; 
        return (
            <div id="page">
                <CoverHeaderXs backgroundImage={ dataCoverHeaderXs.headerBackgroundImage } headerSizeClass={ dataCoverHeaderXs.headerSizeClass } headerTitle={ dataCoverHeaderXs.headerTitle } headerSubTitle={ dataCoverHeaderXs.headerSubTitle }/>
                <div className="gtco-section" id="offer">
                    <SectionContainer className={"gtco-staff " + this.state.animationClasses.join(' ')} style={ { opacity : 0 } }>
                        <Heading2Paragraph content={ { title: dataCareerDevelopYourself.title, paragraph: dataCareerDevelopYourself.paragraph } } />
                        <VisibilitySensor partialVisibility={ true } onChange={ this.headerVisible } >
                            <Row>
                                <Col md={6} className={this.state.animationClasses.join(' ')} style={ { opacity : 0 } }>
                                    <GenericParagraph  text={ dataLeftDeveloperYourselfParagraph }/>
                                </Col>
                                <Col md={6} className={this.state.animationClasses.join(' ')} style={ { opacity : 0 } }>
                                    <GenericParagraph  text= { dataRightDeveloperYourselfParagraph }/>                            
                                </Col>                            
                            </Row>
                        </VisibilitySensor>
                    </SectionContainer>
                </div>  
                <div id="gtco-products">  
                    <SectionContainer>
                        <Heading2Paragraph content={ { title: dataCareerOurOffice.title, paragraph: dataCareerOurOffice.paragraph } } />
                        <Row>
                            <Col md={12}>
                                <Heading3 title={ dataCareerOurOffice.subtitle } />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <GenericParagraph text={ dataCareerOurOfficeSubtitleParagraph } />
                            </Col>
                            <Col md={6}>
                                {dataCareerOurOfficeListLeft.map (value => <li key={value.toString()}>{this.props.translate(value)}</li>)}
                            </Col>
                            <Col md={6}>
                                {dataCareerOurOfficeListRight.map (value => <li key={value.toString()}>{this.props.translate(value)}</li>)}
                            </Col>                            
                        </Row>   
                        <Row>
                            <Carousel items={ dataCarouselItems } />
                        </Row>                   
                    </SectionContainer> 
                </div>  
                <div className="gtco-section">
                    <SectionContainer>
                        <Row className="openings">
                            <Col md={6}>
                                <Heading3 title={ dataCareerOurOpenings } />
                            </Col>
                        </Row>
                        <Row className="openings-jobs">
                            <Col md={12}>
                                <GenericParagraph text={ dataCareerOurOpeningsParagraph } />
                                <FeaturesAccordionSection content={ dataCarrerOpenPositions } />
                            </Col>
                        </Row>
                    </SectionContainer>
                </div>                         
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(CareerPage);


// WEBPACK FOOTER //
// ./src/pages/career-page.js